const t = {
  name: "UpliftTokenize",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17 2H22V7H24V0H17V2Z" fill="currentColor"/>
<path d="M13 4H20V11H18V12.5C18 16.0923 15.0923 19 11.5 19C7.90772 19 5 16.0923 5 12.5C5 8.90771 7.90772 6 11.5 6H13V4ZM13 6V8H11.5C9.01229 8 7 10.0123 7 12.5C7 14.9877 9.01229 17 11.5 17C13.9877 17 16 14.9877 16 12.5V11H18V6H13Z" fill="currentColor"/>
<path d="M13 4H11.5C6.80228 4 3 7.80228 3 12.5C3 17.1977 6.80228 21 11.5 21C16.1977 21 20 17.1977 20 12.5V11H22V12.5C22 18.3023 17.3023 23 11.5 23C5.69772 23 1 18.3023 1 12.5C1 6.69772 5.69772 2 11.5 2H13V4Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as UpliftTokenize
};
